const KEY = 'p3_session';

/** The signed-in Freshroad Travel Pass session token, or '' for a guest. */
export function sessionToken() {
  try {
    return localStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
}

export function setSessionToken(token) {
  try {
    if (token) localStorage.setItem(KEY, token);
    else localStorage.removeItem(KEY);
  } catch {
    /* private mode: the session lasts until the tab closes */
  }
}

export const authHeaders = () => (sessionToken() ? { Authorization: `Bearer ${sessionToken()}` } : {});
